import { Routes, Route, BrowserRouter } from "react-router-dom";
import "./styles/style-index.scss";
import Login from "./Login/Login";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/*"
          element={
            <main>
              <Login />
            </main>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
